import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image";
import { Col, Container, Row } from 'react-bootstrap';

import './outcomes.scss';
import Html from '../../components/paragraph/html';

export default ({
  field_outcomes,
  field_outcomes_image,
  ...rest
}) => {
  const data = useStaticQuery(graphql`
    query {
      outcomeSVG: file(
        relativePath: { eq: "outcome-icon--white.svg" }
      ) {
        publicURL
      }
      resultSVG: file(
        relativePath: { eq: "solution-icon--white.svg" }
      ) {
        publicURL
      }
    }
  `);

  const imageOutcomes = (
    <div className={'background-cover'}>
      {field_outcomes_image.relationships.field_media_image.localFile
        .childImageSharp && (
        <GatsbyImage
          image={field_outcomes_image.relationships.field_media_image
            .localFile.childImageSharp.gatsbyImageData}
          imgStyle={{ objectFit: 'cover' }}
          style={{ height: '100%' }}
          alt={field_outcomes_image.field_media_image.alt} />
      )}

      {!field_outcomes_image.relationships.field_media_image.localFile
        .childImageSharp && <p> SVG not supported in this zone! </p>}
    </div>
  );

  const iconOutcomes = (
    <Col xs={12} md={6} className="outcomes">
      <img
        src={data.outcomeSVG.publicURL}
        alt={'Case Study Outcomes'}
        className="svg"
      />
      <h3 style={{ fontSize: '2.4rem' }}>Outcomes achieved</h3>
      <Html
        props={
          field_outcomes.relationships.field_image_s_text_link[0]
            .field_html
        }
      />
      {/* <Link to="/technologies" className={'btn btn-secondary'}>
        Our Outcomes
      </Link> */}
    </Col>
  );
  const iconSolution = (
    <Col xs={12} md={6} className="solutions">
      <img
        src={data.resultSVG.publicURL}
        alt={'Case Study Technologies'}
        className="svg"
      />
      <h3 style={{ fontSize: '2.4rem' }}>Technologies used</h3>
      <Html
        props={
          field_outcomes.relationships.field_image_s_text_link[1]
            .field_html
        }
      />
      <Link
        to="/services"
        className={'btn btn-secondary'}
        style={{ marginTop: 20 }}
      >
        Our Solutions
      </Link>
    </Col>
  );

  return (
    <section {...rest}>
      {imageOutcomes}
      <div
        className="background-cover"
        style={{
          backgroundColor: 'rgba(35, 31, 32, 0.85)',
          position: 'absolute',
          top: '0',
          left: '0',
          height: '100%',
          width: '100%',
        }}
      ></div>
      ;
      <Container>
        <Row>
          {iconOutcomes}
          {iconSolution}
        </Row>
      </Container>
    </section>
  );
};
